const languageTypes={
    SET_LANGUAGE:'SET_LANGUAGE'
}

export default languageTypes